import { useMe } from "@auth/useMe"
import { useSuspenseQuery } from "@tanstack/react-query"
import { Navigate, createFileRoute } from "@tanstack/react-router"
import { Flex } from "@ui"
import type { FC } from "react"

import { queryClient } from "../../queryClient"
import { solutionSettingsQuery } from "./-shared/solutionSettings.query"
import { WidgetPreview } from "./base-modules/-components/WidgetPreview"
import { Route as BaseModulesRoute } from "./base-modules/index"

const WidgetPreviewPage: FC = () => {
  const { hasSuperpowers } = useMe()
  const { data: solutionSettings } = useSuspenseQuery(solutionSettingsQuery)

  if (!hasSuperpowers) {
    return <Navigate to={BaseModulesRoute.fullPath} />
  }

  return (
    <Flex
      flexDirection="column"
      height="viewport"
      overflow="hidden"
      padding="lg"
    >
      <WidgetPreview
        key={solutionSettings.solutionUid}
        solutionSettings={solutionSettings}
      />
    </Flex>
  )
}

export const Route = createFileRoute("/_authenticated/widget-preview")({
  loader: () => {
    return queryClient.ensureQueryData(solutionSettingsQuery)
  },
  component: WidgetPreviewPage,
})
